<template>
    <FormKit type="form" :actions="false">
        <div class="d-inline-flex input-wrapper">
            <FormKit
                type="time"
                v-model="time"
                validation="required"
                name="time"
                @input="onChange"
                :disabled="isUpdating"
                :key="timeSlot.id"
                :classes="{
                    input: 'input',
                    wrapper: 'fk-wrapper'
                }"
            />

            <div>
                <button
                    type="button"
                    class="remove-btn"
                    data-toggle="modal"
                    :data-target="`#remove-slot-${timeSlot.id}`"
                    ref="toggle-btn"
                    :disabled="isUpdating"
                >
                    <i class="las la-times-circle"></i>
                </button>

                <div
                    class="modal fade"
                    :id="`remove-slot-${timeSlot.id}`"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="remove-slot-label"
                    aria-hidden="true"
                >
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="remove-slot-label">
                                    Verwijder tijdslot
                                </h5>
                                <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p class="mb-0">
                                    Als het tijdslot is verwijderd is het niet
                                    meer mogelijk om dit terug te draaien.
                                </p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    data-dismiss="modal"
                                    :disabled="isUpdating"
                                >
                                    Annuleren
                                </button>

                                <button
                                    data-dismiss="modal"
                                    type="button"
                                    class="btn btn-danger"
                                    @click="deleteSlot"
                                    :disabled="isUpdating"
                                >
                                    Verwijderen
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </FormKit>
</template>

<script>
export default {
    name: "SlotEditForm",
    props: {
        timeSlot: {
            type: Object,
        },
    },
    data() {
        return {
            isUpdating: false,
            timeout: null,
            time: this.timeSlot?.time,
        };
    },
    methods: {
        async onChange() {
            clearTimeout(this.timeout);

            if (!this.time) {
                return;
            }

            // Debounce
            this.timeout = setTimeout(async () => {
                this.isUpdating = true;

                try {
                    await axios.patch(`/admin/api/slots/${this.timeSlot.id}`, {
                        time: this.time,
                    });

                    this.$emit("on-update");
                } catch (e) {
                    alert("Slot couldn't be edited");
                } finally {
                    this.isUpdating = false;
                }
            }, 1000);
        },
        async deleteSlot() {
            this.isUpdating = true;

            try {
                await axios.delete(`/admin/api/slots/${this.timeSlot.id}`);

                this.$emit("on-update");
            } catch (e) {
                alert("Slot couldn't be removed");
            } finally {
                this.isUpdating = false;

              var elems = document.querySelectorAll('body');

              [].forEach.call(elems, function(el) {
                el.classList.remove("modal-open");
              });
            }
        },
    },
    watch: {
        timeSlot: {
            immediate: false,
            deep: true,
            handler() {
                this.time = this.timeSlot?.time;
            },
        },
    },
    unmounted() {
        clearTimeout(this.timeout);
    },
};
</script>

<style scoped>
/deep/ .input {
    padding: 0;
    border: none;
    font-size: 14px;
}

/deep/ .input::-webkit-calendar-picker-indicator {
    background: none;
    display: none;
}

/deep/ .fk-wrapper {
    margin-bottom: 0 !important;
    margin-right: 0.4rem;
}

.input-wrapper {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0,40,100,.12);
    padding: 0 0.5rem;
    border-radius: 3px;
}

.remove-btn {
    border: none;
    padding: 0;
    background: transparent;
    color: #df4759;
}
</style>
